import Modal from 'ud-ui/components/modal';

interface RemoveConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Подтверждение удаления картинки.
 *
 * Спрашиваем, потому что промахнуться по крестику легко, а вернуть картинку
 * нечем: файл выбирают заново, а сохранённое фото после сохранения формы
 * пропадает с бэкенда.
 */
export function RemoveConfirmModal({ isOpen, onCancel, onConfirm }: RemoveConfirmModalProps) {
  return (
    <Modal.Confirm
      show={isOpen}
      title="Удалить изображение?"
      description="После сохранения изображение будет удалено."
      confirmText="Удалить"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
